// src/icons.js
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  // Core icons
  faHome,
  faBolt,
  faThLarge,
  faBell,
  faSignOutAlt,
  faUser,
  faGamepad,
  faPaintBrush,
  faUserCircle,
  faChevronDown,
  faLightbulb,
  faCalendarAlt,
  faCalendarDay,
  faCalendarWeek,
  faChartLine,
  faPalette,
  faPlus,
  faTimes,
  faSync,
  faArrowUp,
  faArrowDown,
  faRocket,
  faUsers,
  faChartBar,
  faPlayCircle,
  faClock,
  faEye,
  faHeart,
  faShare,
  faComment,
  faCog,
  faExclamationTriangle,
  faCheckCircle,
  faFilter,
  faCalendar,
  faGlobe,
  faDollarSign,
  faBullseye,
  faChartPie,
  faTable,
  faDownload,
  faChevronRight,
  faChevronLeft,
  faCrown,
  faStar,
  faFire,
  faUserFriends,
  faThumbsUp,
  faBookmark,
  faLink,
  faSearch,
  faInfoCircle,
  faExternalLinkAlt,
  faMinus,
  faUserPlus,
  faUserMinus,
  faComments,
  faFileAlt,
  faBars,
  faVideo,
  faRetweet,
  // Affiliate dashboard icons (only the ones actually used)
  faHandshake,
  faTrophy,
  faPercentage,
  faHistory,
  faCopy,
  faCheck,
  faLock,
  faGift,
  faAward,
  faMedal,
  faCoins,
  faMoneyBillWave,
  faChartArea,
  faArrowTrendUp,
  faUsersCog,
  faClipboardList,
  faReceipt,
  faCreditCard,
  faWallet,
  faPiggyBank,
  faShieldAlt,
  faCertificate,
  faGraduationCap,
  faEnvelope,
  faCalendarPlus,
  faCircle,
  faQrcode,
  faMobileAlt,
  faPhone,
  faAt,
  faHeadset,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(
  // Core icons
  faHome,
  faBolt,
  faThLarge,
  faBell,
  faSignOutAlt,
  faUser,
  faGamepad,
  faPaintBrush,
  faUserCircle,
  faChevronDown,
  faLightbulb,
  faCalendarAlt,
  faCalendarDay,
  faCalendarWeek,
  faChartLine,
  faPalette,
  faPlus,
  faTimes,
  faSync,
  faArrowUp,
  faArrowDown,
  faRocket,
  faUsers,
  faChartBar,
  faPlayCircle,
  faClock,
  faEye,
  faHeart,
  faShare,
  faComment,
  faCog,
  faExclamationTriangle,
  faCheckCircle,
  faFilter,
  faCalendar,
  faGlobe,
  faDollarSign,
  faBullseye,
  faChartPie,
  faTable,
  faDownload,
  faChevronRight,
  faChevronLeft,
  faCrown,
  faStar,
  faFire,
  faUserFriends,
  faThumbsUp,
  faBookmark,
  faLink,
  faSearch,
  faInfoCircle,
  faExternalLinkAlt,
  faMinus,
  faUserPlus,
  faUserMinus,
  faComments,
  faFileAlt,
  faBars,
  faVideo,
  faRetweet,
  // Affiliate dashboard icons (only the ones actually used)
  faHandshake,
  faTrophy,
  faPercentage,
  faHistory,
  faCopy,
  faCheck,
  faLock,
  faGift,
  faAward,
  faMedal,
  faCoins,
  faMoneyBillWave,
  faChartArea,
  faArrowTrendUp,
  faUsersCog,
  faClipboardList,
  faReceipt,
  faCreditCard,
  faWallet,
  faPiggyBank,
  faShieldAlt,
  faCertificate,
  faGraduationCap,
  faEnvelope,
  faCalendarPlus,
  faCircle,
  faQrcode,
  faMobileAlt,
  faPhone,
  faAt,
  faHeadset,
  faExclamationCircle
);
